/** Articles that live in the codebase (not the CMS). Listed on the blog index and used as the homepage fallback. Newest first. */
export type StaticPost = {
  slug: string;
  title: string;
  excerpt: string;
  date: string;
  image: string;
  imageAlt: string;
  readMinutes: number;
};

export const staticPosts: StaticPost[] = [
  {
    slug: "storage-and-demurrage-billing-from-the-container-record",
    title: "Storage and demurrage billing from the container record",
    excerpt: "Why depots that bill from registers lose revenue and argue with customers, and how a container record with free days, slabs, and customer tariffs changes the month.",
    date: "2026-09-24",
    image: "/static/img/industries/container-yard.jpg",
    imageAlt: "Container yard with stacked containers and a reach stacker",
    readMinutes: 6,
  },
  {
    slug: "multi-currency-invoicing-in-sap-business-one-for-exporters",
    title: "Multi-currency invoicing in SAP Business One for exporters",
    excerpt: "Buy in local currency, sell in USD, report in both: how exchange rates, revaluation, and realised differences work in SAP Business One, and the setup decisions to make first.",
    date: "2026-09-24",
    image: "/static/img/industries/commodity-export.jpg",
    imageAlt: "Sacks of export commodities being loaded toward shipping containers at a port",
    readMinutes: 7,
  },
  {
    slug: "sap-implementation-success-strategic-framework",
    title: "SAP implementation: a practical framework",
    excerpt: "The five phases of an SAP implementation, from defining what success means to realising value after go-live.",
    date: "2025-06-10",
    image: "/static/img/blog/sapb1.png",
    imageAlt: "SAP implementation framework illustration",
    readMinutes: 8,
  },
  {
    slug: "revolutionizing-business-processes-erp-integration",
    title: "ERP integration: connecting the systems a business already runs",
    excerpt: "Where integration pays off, where it does not, and how to scope the connections between an ERP and the tools around it.",
    date: "2025-05-05",
    image: "/static/img/blog/erp.png",
    imageAlt: "ERP integration illustration",
    readMinutes: 7,
  },
  {
    slug: "building-lasting-relationships-crm-excellence",
    title: "CRM that people actually use: keeping every follow-up",
    excerpt: "What separates a CRM that sales teams keep updated from one they abandon, and how to set one up around real follow-ups.",
    date: "2025-04-15",
    image: "/static/img/blog/crm.png",
    imageAlt: "CRM follow-up illustration",
    readMinutes: 6,
  },
];
